<template>
	<footer class="ui inverted vertical segment m-padded-tb-large m-opacity">
		<div class="ui center aligned container">
			<div class="ui inverted divided stackable grid">

				<div class="three wide column">
					<div class="ui link list">
						<!-- <h4 class="ui inverted header m-text-thin m-text-spaced">{{ siteInfo.footerImgTitle }}</h4> -->
						<div class="item">
							<img :src="siteInfo.footerImgUrl" class="ui rounded image" alt="" style="width: 100px">
						</div>
					</div>
				</div>

				<div class="six wide column">
					<h4 class="ui inverted header m-text-thin m-text-spaced">网站资讯</h4>
					<!-- <div class="ui inverted link list">
						<a href="javascript:;" @click.prevent="toBlog(item)" v-for="item in newBlogList" :key="item.id"
							class="item m-text-thin m-padded-tb-small">{{ item.title }}</a>
					</div> -->
					<p class="m-text-thin m-text-spaced m-opacity-mini">
						博客已偷偷运行
						<span id="htmer_time" style="color: #00BFFF; font-weight: bold; ">
							加载中...
						</span>
					</p>

				</div>

				<div class="seven wide column">
					<p id="hitokotoText" class="m-text-thin m-text-spaced m-opacity-mini">{{ hitokoto.hitokoto }}</p>
					<p id="hitokotoFrom" class="m-text-thin m-text-spaced m-opacity-mini" style="float: right"
						v-text="hitokoto.from ? `——《${hitokoto.from}》` : ''"></p>
				</div>
			</div>

			<div class="ui inverted section divider"></div>

			<p class="m-text-thin m-text-spaced m-opacity-tiny">
				<span style="margin-right: 10px" v-if="siteInfo.copyright">{{ siteInfo.copyright.title }}</span>
				<router-link to="/" style="color:#ffe500" v-if="siteInfo.copyright">{{ siteInfo.copyright.siteName
					}}</router-link>
				<span style="margin: 0 15px" v-if="siteInfo.copyright && siteInfo.beian">|</span>
				<a rel="external nofollow noopener" href="https://beian.miit.gov.cn/" target="_blank"
					style="color:#ffe500">{{ siteInfo.beian }}</a>
			</p>

			<div class="github-badge" v-for="(item, index) in badges" :key="index">
				<a rel="external nofollow noopener" :href="item.url" target="_blank" :title="item.title">
					<span class="badge-subject">{{ item.subject }}</span>
					<span class="badge-value" :class="`bg-${item.color}`">{{ item.value }}</span>
				</a>
			</div>

		</div>
	</footer>
</template>

<script>
export default {
	name: "Footer",
	props: {
		siteInfo: {
			type: Object,
			required: true
		},
		badges: {
			type: Array,
			required: true
		},
		// newBlogList: {
		// 	type: Array,
		// 	required: true
		// },
		hitokoto: {
			type: Object,
			required: true
		}
	},
	methods: {
		toBlog(blog) {
			this.$store.dispatch('goBlogPage', blog)
		}
	}
}
function secondToDate(second) {
	if (!second) {
		return [0, 0, 0, 0, 0];
	}
	var time = [0, 0, 0, 0, 0];
	if (second >= 24 * 3600) {
		time[1] = parseInt(second / (24 * 3600));
		second %= 24 * 3600;
	}
	if (second >= 3600) {
		time[2] = parseInt(second / 3600);
		second %= 3600;
	}
	if (second >= 60) {
		time[3] = parseInt(second / 60);
		second %= 60;
	}
	if (second > 0) {
		time[4] = second;
	}
	return time;
}

function setTime() {
	// 博客创建时间（UTC时间）
	var createTime = Math.round(new Date(Date.UTC(2024, 2, 10, 0, 0, 0)).getTime() / 1000);
	// 当前时间（也使用UTC时间保持一致性）
	var currentTimeStamp = Math.round(new Date().getTime() / 1000);

	// 计算时间差
	var timeDiff = currentTimeStamp - createTime;
	if (timeDiff < 0) {
		console.error("当前时间早于创建时间！");
		return;
	}
	var currentTime = secondToDate(timeDiff);

	// 格式化输出
	var currentTimeHtml = currentTime[1] + "天 " +
		currentTime[2] + "时 " +
		currentTime[3] + "分 " +
		currentTime[4] + "秒";

	// 更新到页面
	var timeElement = document.getElementById("htmer_time");
	if (timeElement) {
		timeElement.innerHTML = currentTimeHtml;
	}
}

// 定时更新时间
setInterval(setTime, 1000);
</script>

<style scoped>
@import "../../assets/css/badge.css";

.github-badge a {
	color: #fff;
}
</style>